import { render, staticRenderFns } from "./SaleSkinModal.vue?vue&type=template&id=47d79eb8"
import script from "./SaleSkinModal.vue?vue&type=script&lang=js"
export * from "./SaleSkinModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports